import { render, staticRenderFns } from "./ViewCommonDocument.vue?vue&type=template&id=b6ae0c7a&"
import script from "./ViewCommonDocument.vue?vue&type=script&lang=js&"
export * from "./ViewCommonDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports